import { createFileRoute } from '@tanstack/react-router';
import { TenantModulesPage } from '@/features/tenant-modules/TenantModulesPage';

/**
 * Moduli attivi — gli interruttori `<modulo>.enabled` dell'azienda corrente, letti da
 * `GET /api/tenant-modules` e scritti sulla riga di `tenant-attributes` (BE-CONTRACT-TENANT-MODULES-v1).
 *
 * Dal 11-09-2026 spegnere un modulo blocca **ogni** sua rotta per chiunque, super-admin compreso:
 * questa pagina esiste perche' quel gesto dica prima cosa chiude, e perche' «acceso per scelta» e
 * «acceso perche' la riga non c'e'» siano due cose leggibili e non una sola.
 */
export const Route = createFileRoute('/_app/admin/modules')({ component: TenantModulesPage });
